<template>
    <b-container class="mt-5">
        <b-row class="justify-content-md-center" align-v="center">
            <b-col md="5">
                <b-form @submit="onSubmit">
                    <b-form-group id="usernameInputGroup"
                                    label="Username:"
                                    label-for="authUsername">
                        <b-form-input id="authUsername"
                                    type="text"
                                    v-model="form.username"
                                    required
                                    placeholder="Enter Username">
                        </b-form-input>
                    </b-form-group>
                    <b-form-group id="passwordInputGroup"
                                    label="Password:"
                                    label-for="authPassword">
                        <b-form-input id="authPassword"
                                    type="password"
                                    v-model="form.password"
                                    required
                                    placeholder="Enter password">
                        </b-form-input>
                    </b-form-group>
                    <b-button type="submit" variant="primary" class="mr-1">Submit</b-button>
                    <b-button type="reset" variant="danger">Reset</b-button>
                </b-form>
            </b-col>
        </b-row>
    </b-container>
</template>

<script>
export default {
  data () {
    return {
      form: {
        username: '',
        password: ''
      }
    }
  },
  methods: {
    onSubmit: function (evt) {
      evt.preventDefault()
      this.$http.post('/public/login', this.form)
        .then(response => {
          window.console.log(response)
          this.$store.commit('setAuthToken', response.headers.authorization.replace('Bearer ', ''))
          this.$router.push('/')
        })
        .catch(error => {
          window.console.log(error)
        })
    }
  }
}
</script>

